// kept out of Markdown.tsx so importing the tag list does not pull in react-markdown
export const MARKDOWN_TAGS = [
  'a',
  'strong',
  'em',
  'code',
  'p',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'li',
  'liCustom',
  'ul',
  'ol',
  'img',
  'hr',
] as const;

export type MarkdownTag = (typeof MARKDOWN_TAGS)[number];
